export default {
  name: "focus",
  components: {},
  props: [],
  data() {
    return {serviceHeaderStyles:{'text-align':'justify', 'font-weight':500, 'text-transform':'uppercase', 'line-height':'30px'},
            serviceTextStyles:{'line-height':'34px'}};
  },
  computed: {},
  mounted() {},
  methods: {}
};
